
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class KaleidoscopeMirrorEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const segments = Math.floor(8 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 2 * scale;

        const drawSegment = () => {
            ctx.beginPath();
            ctx.moveTo(50 * scale, 50 * scale);
            ctx.lineTo(150 * scale, 100 * scale);
            ctx.lineTo(100 * scale, 200 * scale);
            ctx.stroke();
            
            ctx.beginPath();
            ctx.arc(120 * scale, 120 * scale, 30 * scale, 0, Math.PI * 2);
            ctx.stroke();
        };

        const draw = () => {
            ctx.save();
            for (let i = 0; i < segments; i++) {
                ctx.rotate((Math.PI * 2) / segments);
                ctx.save();
                ctx.translate(Math.sin(curTime + i) * 50, Math.cos(curTime + i) * 50);
                drawSegment();
                ctx.restore();
                
                // Mirror
                ctx.save();
                ctx.scale(1, -1);
                ctx.translate(Math.sin(curTime + i) * 50, Math.cos(curTime + i) * 50);
                drawSegment();
                ctx.restore();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
